export default "__VITE_ASSET__CBs4Qgm4__"